import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {companyDimensions} from "../../../db/models/const";
import {companySectors} from "../../../db/datasets/company-sectors";
import {openDialog} from "../../../slices/dialog";
import {EditCompanyInfo} from "../../CommonComponents";
import EditIcon from "@material-ui/icons/Edit";
import LinkIcon from "@material-ui/icons/Link";
import ButtonCircle from "../../Common/ButtonCircle";
import "./Info.scss";
import {useTranslation} from "react-i18next";
import {Row,Col} from "react-bootstrap";

export const CardCompanyInfo = ({company, editable}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const sector = company?.sector != null ? t(companySectors[company.sector].label) : "Settore";
    const headquarter = company?.headquarter || "";
    const website = company?.website || "Sito web";
    const primaryColor = "#" + (company?.primaryColor && company.primaryColor.length === 6 ? company.primaryColor : "FFFFFF");
    const secondaryColor = "#" + (company?.secondaryColor && company.secondaryColor.length === 6 ? company.secondaryColor : "FFFFFF");
    const [textColor, setTextcolor] = useState("#444444");
    const dimension = company?.dimension != null ? companyDimensions[company.dimension].label : "Numero";

    useEffect(() => {
        const color = primaryColor.substring(1, 7);
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);
        setTextcolor(((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186 ? "#444444" : "#FFFFFF");
    }, [primaryColor, secondaryColor])

    const onEditClick = () => {
        dispatch(openDialog({
            Content: EditCompanyInfo,
            title: t("company_editInfo_title"),
            closable: true
        }));
    };

    return (
        <div className="companyInfo card" style={{
            background: `linear-gradient(120deg, ${primaryColor} 0%, ${primaryColor} 70%, ${secondaryColor} 100%)`,
            // backgroundColor: "#FF5733",
            color: textColor
        }}>
            <div className="innerCard">
                <div
                    className="innerCard__logo"
                    style={{
                        backgroundImage: `url(${company?.logoUrl})` || null,
                        backgroundColor: company?.logoUrl ? "#ffffff" : "#234562"
                    }}
                ></div>
                <div className="innerCard__info">
                    <div className="header">
                        <div className="title">{company?.name}</div>
                        {editable && <ButtonCircle negative={textColor === "#FFFFFF"}
                                                   onClick={() => onEditClick()}><EditIcon/></ButtonCircle>}
                    </div>
                    <p className="subtitle">
                        {sector}{headquarter && " | " + headquarter}{" | "}{dimension}{t("company_dimension")}
                    </p>
                    <div className="info__link">
                        <LinkIcon/>
                        <a className="website" target="_blank" rel="noopener noreferrer"
                           href={website}>{t("company_website")}</a>
                    </div>
                    <p className="mission">
                        {company?.mission || "Mission da inserire"}
                    </p>
                    <Row className={"mb-0"}>
                        <Col>
                            <div className="info__chips">
                                <p className="chip">
                                    {t("company_studentCounter") + " " + (company?.followerCount || 0)}
                                </p>
                                <p className="chip">
                                    {t("company_pathCounter") + " " + (company?.rmCount || 0)}
                                </p>
                                <p className="chip">
                                    {t("company_gameCounter") + " " + (company?.gameCount || 0)}
                                </p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} className="d-flex justify-content-end align-items-end">
                            {company?.manager &&
                                <div className="d-flex flex-row align-items-center ps-2 py-2 pe-3 circle-borders bg-white text-black">
                                    <img className="me-2 powered_by_logo oval-borders"
                                        // src={company?.logoUrl} alt="powered by logo"/>
                                         src={company?.manager.logo} alt="powered by logo"/>
                                    <p className={"text-nowrap fs-4"}><span>Powered By </span><span className="fw-bold">{company?.manager.name}</span></p>
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}